import React from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

const Tabs = ({ children }) => {
    return (
        <View style={styles.tabContainer}>
            {children}
        </View>
    );
};

Tabs.propTypes = {
    children: PropTypes.node.isRequired,
};

const styles = StyleSheet.create({
    tabContainer: {
        height: defaultScale(50),
        flexDirection: 'row',
        borderColor: Theme.GREY_MEDIUM,
    },
});

export default Tabs;
